import React, { Component } from "react";
import ReactGA from "react-ga";
import $ from "jquery";
import "./App.css";
import Verification from "./Components/Verification";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Pricing from "./Components/Pricing";
import Portfolio from "./Components/Portfolio";
import "@fortawesome/fontawesome-free/css/all.min.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      foo: "bar",
      portfolioData: {},
    };

    ReactGA.initialize("UA-110570651-1");
    ReactGA.pageview(window.location.pathname);
  }

  getPortfolioData() {
    $.ajax({
      url: "./portfolioData.json",
      dataType: "json",
      cache: false,
      success: function (data) {
        this.setState({ portfolioData: data });
      }.bind(this),
      error: function (xhr, status, err) {
        console.log(err);
        alert(err);
      },
    });
  }

  componentDidMount() {
    this.getPortfolioData();
  }

  render() {
    return (
      <div className="App">
        <Header data={this.state.portfolioData.main} />
        <Verification />
        <Portfolio data={this.state.portfolioData.portfolio} />
        <Pricing data={this.state.portfolioData.pricing} />
        <About data={this.state.portfolioData.main} />
        <Footer data={this.state.portfolioData.main} />
      </div>
    );
  }
}

export default App;
